import {Button, Form, Input, Select} from "antd";
import {useEffect, useRef, useState} from "react";
import {useUser} from "../context/UserContext";
import ApiService from "../services/ApiService";
import CountryList from "../services/CountryList";
import USStateList from "../services/USStateList";

export default function EditProfile()
{
    const {user, setUser} = useUser();
    const [country, setCountry] = useState('')
    const form = useRef();

    const onFinish = async () => {
        const res = await ApiService.User.EditUser({
            ...form.current.getFieldsValue()
        })

        if(res.success) {
            const u = res.data;
            setUser(u)
        }
    }

    useEffect(() => {
        if(user && user.data) {
            setCountry(user.data.country)
            form.current.setFieldsValue({
                ...user.data
            })
        }
    }, [user])

    return (
        <>
            <Form
                ref={form}
                layout={'vertical'}
                onFinish={onFinish}
            >
                <Form.Item
                    name="email"
                    label="E-mail"
                    rules={[
                        {
                            type: 'email',
                            message: 'The input is not valid E-mail!',
                        },
                        {
                            required: true,
                            message: 'Please input your E-mail!',
                        },
                    ]}
                >
                    <Input style={{width: '100%'}} />
                </Form.Item>

                <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                    <Form.Item
                        style={{flex: 1}}
                        name={'name'}
                        label={'Name'}
                        rules={[{required: true, min: 3}]}
                    >
                        <Input />
                    </Form.Item>

                    <Form.Item
                        style={{flex: 1}}
                        name={'lastname'}
                        label={'Lastname'}
                        rules={[{required: true, min: 3}]}
                    >
                        <Input />
                    </Form.Item>
                </div>

                <Form.Item
                    style={{flex: 1}}
                    name={'company'}
                    label={'Company'}
                    rules={[{required: true, min: 3}]}
                >
                    <Input />
                </Form.Item>

                <div style={{display: 'flex', alignItems: 'center', gap: 8}}>
                    <Form.Item
                        style={{flex: 1}}
                        name={'city'}
                        label={'City'}
                        rules={[{required: true, min: 3}]}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        style={{flex: 1}}
                        name={'state'}
                        label={'State'}
                        rules={[{required: true}]}
                    >
                        {
                            country === 'United States'
                                ? (
                                    <Select
                                        showSearch={true}
                                        filterOption={(inputValue, option) => {
                                            return option.value.toLowerCase().includes(inputValue.toLocaleLowerCase())
                                        }}
                                    >
                                        {
                                            USStateList.map(c => (
                                                <Select.Option value={c.name}>
                                                    {c.name}
                                                </Select.Option>
                                            ))
                                        }
                                    </Select>
                                )
                                : (
                                    <Input />
                                )
                        }

                    </Form.Item>
                    <Form.Item
                        style={{flex: 1}}
                        name={'country'}
                        label={'Country'}
                        rules={[{required: true, min: 3}]}
                    >
                        <Select
                            onChange={(value, option) => {setCountry(value)}}
                            showSearch={true}
                            filterOption={(inputValue, option) => {
                                return option.value.toLowerCase().includes(inputValue.toLocaleLowerCase())
                            }}
                        >
                            {
                                CountryList.map(c => (
                                    <Select.Option value={c.name}>
                                        {c.name}
                                    </Select.Option>
                                ))
                            }
                        </Select>
                    </Form.Item>
                </div>

                <Form.Item>
                    <Button type={'primary'} htmlType={'submit'}>
                        Save
                    </Button>
                </Form.Item>
            </Form>
        </>
    )
}